"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const detectPosition = async () => {
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  return new Promise(function (resolve) {
    navigator.geolocation.getCurrentPosition(pos => {
      const {
        coords: {
          latitude,
          longitude
        } = {}
      } = pos;
      resolve({
        lat: latitude,
        lng: longitude
      });
    }, err => {
      resolve("error");
    }, options);
  });
};
var _default = exports.default = detectPosition;